module.exports = __webpack_public_path__ + "static/media/profile.5cd3d20c.jpg";